module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"DATE_FORMAT":"{day}. {monthName} {year}","DATE_FORMAT_WEEKDAY":"{weekday}, {day}. {monthName} {year}","TIME_FORMAT":"{hours}:{minutes}"},"en":{"DATE_FORMAT":"{weekday}, {monthName} {day}, {year}","DATE_FORMAT_WEEKDAY":"{monthName} {day}, {year}","TIME_FORMAT":"{hours}.{minutes}"}}')
  delete Component.options._Ctor
}
